import token from '@uipath/apollo-core';
export const MuiLink = (palette) => ({
    root: {
        color: palette.semantic.colorForegroundLink,
        fontWeight: token.FontFamily.FontWeightSemibold,
        '&:visited': { color: palette.semantic.colorForegroundLink },
        '&:focus': { color: palette.semantic.colorForegroundLink },
        '&:active': { color: palette.semantic.colorForegroundLinkPressed },
    },
});
